<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  <div
    *ngFor="let project of projects"
    class="flex flex-col gap-4 p-6 bg-card-light dark:bg-card-dark rounded-xl border border-gray-200 dark:border-gray-800/50 shadow-sm card-hover cursor-pointer"
    (click)="goToProduct(project)"
  >
    <div class="flex items-center gap-4">
      <div
        class="w-16 h-16 flex items-center justify-center rounded-lg text-xl font-medium
              bg-gray-100 text-green-600 dark:bg-gray-700 dark:text-green-400"
      >
        {{ project.title | initials }}
      </div>
      <div class="flex-1">
        <p class="text-lg font-bold font-display text-primary dark:text-primary">
          {{ project.title }}
        </p>
        <p class="text-gray-500 dark:text-gray-400 text-sm font-normal">
          {{ project.subtitle }}
        </p>
      </div>
    </div>
    <p class="text-gray-600 dark:text-gray-300 text-sm">{{ project.description }}</p>
    <div class="flex justify-between items-center mt-2">
      <p class="text-gray-400 dark:text-gray-500 text-xs font-medium">
        Last updated: {{ project.updatedAt }}
      </p>
      <div
      class="flex items-center gap-1 text-accent dark:text-accent text-sm font-bold hover:underline group cursor-pointer"
      (click)="goToProduct(project); $event.stopPropagation()"
    >
      View Details
      <span
        class="material-symbols-outlined text-base transition-transform duration-300 group-hover:translate-x-1"
      >
        arrow_forward
      </span>
    </div>
    </div>
  </div>
</div>
